module.exports = __webpack_public_path__ + "media/images/illustration_4-965926354e212b4e7f9bb711959132b1.png";